// scrcpy wire-protocol constants and message builders.
export const CH_VIDEO = 0;
export const CH_DEVICE_MSG = 3;
export const CH_METADATA = 4;
export const TYPE_KEYCODE = 0;
export const TYPE_TEXT = 1;
export const TYPE_TOUCH = 2;
export const TYPE_GET_CLIPBOARD = 8;
export const TYPE_SET_SCREEN_POWER_MODE = 10;
export const COPY_KEY_NONE = 0;
export const ACTION_DOWN = 0;
export const ACTION_UP = 1;
export const ACTION_MOVE = 2;
export const BUTTON_PRIMARY = 1;
export const MAX_PRESSURE = 0xFFFF;
// scrcpy device-message types (device → host, framed on CH_DEVICE_MSG)
export const DEV_MSG_CLIPBOARD = 0;
export const DEV_MSG_ACK_CLIPBOARD = 1;
// Non-printable keys → Android KeyEvent keycodes (printable chars go via INJECT_TEXT).
export const SPECIAL_KEYCODES = {
    Enter: 66, Backspace: 67, Tab: 61, Escape: 111,
    ArrowUp: 19, ArrowDown: 20, ArrowLeft: 21, ArrowRight: 22,
    Delete: 112, Home: 122, End: 123, PageUp: 92, PageDown: 93,
};
export function buildKeycodeMsg(action, keycode, metaState = 0) {
    const buf = new ArrayBuffer(14);
    const v = new DataView(buf);
    v.setUint8(0, TYPE_KEYCODE);
    v.setUint8(1, action);
    v.setInt32(2, keycode, false);
    v.setInt32(6, 0, false); // repeat
    v.setInt32(10, metaState, false); // metaState (shift/ctrl/alt bitmask)
    return buf;
}
// scrcpy SET_SCREEN_POWER_MODE: type(1) + mode(1). mode 0 = screen off (panel dark,
// stream keeps running), 1 = on. Holds only while the scrcpy session is connected.
export function buildScreenPowerMsg(on) {
    const buf = new ArrayBuffer(2);
    const v = new DataView(buf);
    v.setUint8(0, TYPE_SET_SCREEN_POWER_MODE);
    v.setUint8(1, on ? 1 : 0);
    return buf;
}
// scrcpy INJECT_TEXT: type(1) + length(4 BE) + UTF-8 bytes
export function buildTextMsg(text) {
    const bytes = new TextEncoder().encode(text);
    const buf = new ArrayBuffer(5 + bytes.length);
    const v = new DataView(buf);
    v.setUint8(0, TYPE_TEXT);
    v.setUint32(1, bytes.length, false);
    new Uint8Array(buf, 5).set(bytes);
    return buf;
}
export function buildTouchMsg(action, px, py, screenW, screenH, buttons) {
    const actionButton = action !== ACTION_MOVE ? BUTTON_PRIMARY : 0;
    const pressure = action === ACTION_UP ? 0 : MAX_PRESSURE;
    const buf = new ArrayBuffer(32);
    const v = new DataView(buf);
    v.setUint8(0, TYPE_TOUCH);
    v.setUint8(1, action);
    v.setUint32(2, 0, false);
    v.setUint32(6, 0xFFFFFFFF, false);
    v.setUint32(10, px, false);
    v.setUint32(14, py, false);
    v.setUint16(18, screenW, false);
    v.setUint16(20, screenH, false);
    v.setUint16(22, pressure, false);
    v.setUint32(24, actionButton, false);
    v.setUint32(28, buttons, false);
    return buf;
}
export const PTS_CONFIG = 0x8000000000000000n;
export const PTS_KEYFRAME = 0x4000000000000000n;
export const PTS_MASK = 0x3fffffffffffffffn;
export const CODEC_STRINGS = {
    h264: 'avc1.42E01E',
    h265: 'hev1.1.6.L93.B0',
    av1: 'av01.0.04M.08',
};
/**
 * Not a WebCodecs codec at all: the metadata value an aggregator phone announces when
 * its "video" is a stream of whole JPEG stills (a timed accessibility screen grab, a
 * few frames per second) rather than an elementary stream. Framed on the wire exactly
 * like H.264 — every still flagged KEYFRAME, no CONFIG frame — so the relay's fan-out
 * and last-frame cache treat it identically; only the browser's decode differs.
 */
export const CODEC_MJPEG = 'mjpeg';
